import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-2xl overflow-hidden border border-slate-200">
                <div className="bg-slate-900 px-8 py-10 text-white">
                    <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
                    <p className="text-slate-400">Effective Date: February 23, 2026</p>
                </div>

                <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">1. Introduction</h2>
                        <p>
                            Paper Portal ("Company", "we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you visit paperportal.in.
                        </p>
                        <p className="mt-4 font-semibold">
                            Please note that all personal data is collected, stored, and processed within India.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">2. Information Collection</h2>
                        <p>We may collect the following types of information:</p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Identity Data:</strong> Name, Date of Birth, Gender, and professional credentials.</li>
                            <li><strong>Contact Data:</strong> Email address, phone numbers, and physical address.</li>
                            <li><strong>Transaction Data:</strong> Payment details (processed via secure third-party gateways), purchase history, and service usage.</li>
                            <li><strong>Technical Data:</strong> IP address, browser type, and device information.</li>
                            <li><strong>Profile Data:</strong> Username, password (encrypted), preferences, and feedback.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">3. Usage of Data</h2>
                        <p>We use your data for the following purposes:</p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li>To provide and manage our services.</li>
                            <li>To process payments and prevent fraudulent transactions.</li>
                            <li>To personalize user experience and improve our platform.</li>
                            <li>To communicate updates, security alerts, and support responses.</li>
                            <li>To comply with legal and regulatory requirements under Indian law.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">4. Sharing with Third Parties</h2>
                        <p>
                            We do not sell your personal data. We may share information with trusted third parties only in the following cases:
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Service Providers:</strong> Payment gateways, cloud storage providers, and analytical tools.</li>
                            <li><strong>Legal Obligations:</strong> When required by law or to respond to legal processes from governmental authorities.</li>
                            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">5. Security Practices</h2>
                        <p>
                            We implement industry-standard security measures, including encryption (SSL/TLS), firewalls, and secure access controls to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">6. Data Retention</h2>
                        <p>
                            We retain your personal data only for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">7. User Rights</h2>
                        <p>You have the following rights regarding your personal data:</p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
                            <li><strong>Update:</strong> Request correction of inaccurate or incomplete data.</li>
                            <li><strong>Delete:</strong> Request erasure of your personal data under certain conditions.</li>
                            <li><strong>Withdraw Consent:</strong> Withdraw your consent at any time where we are relying on consent to process your data.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">8. Consent & Withdrawal</h2>
                        <p>
                            By using our Website, you consent to the collection and use of your data as described in this policy. You may withdraw your consent by contacting our Grievance Officer, but please note that this may limit our ability to provide certain services to you.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">9. Changes to Policy</h2>
                        <p>
                            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                        </p>
                    </section>

                    <section className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                        <h2 className="text-xl font-bold text-slate-900 mb-4">Grievance Officer</h2>
                        <div className="space-y-2 text-sm md:text-base">
                            <p><strong>Name:</strong> Shamiul Rana</p>
                            <p><strong>Designation:</strong> Grievance Officer</p>
                            <p><strong>Address:</strong> 5 Bibhuti Bhusan Bandopadhay Sarani, Kolkata 700019, West Bengal, India</p>
                            <p><strong>Email:</strong> helpdesk@paperportal.com</p>
                            <p><strong>Phone:</strong> +91 7890 10 4000</p>
                            <p><strong>Working Hours:</strong> Monday - Friday (9:00 - 18:00)</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
